<script>
  import {
    SaveIcon,
    DownloadIcon,
    RotateCcwIcon,
    MessageCircleIcon,
  } from 'vue-feather-icons'
  import {
    windowsComputed,
  } from '@state/helpers'

  export default {
    components: {
      SaveIcon,
      DownloadIcon,
      RotateCcwIcon,
      MessageCircleIcon,
    },
    props: {
      hasDownload: {
        type: Boolean,
        default: false,
      },
      hasSaveComments: {
        type: Boolean,
        default: false,
      },
      isDisabled: {
        type: Boolean,
        default: false,
      },
      isPositiveDisabled: {
        type: Boolean,
        default: false,
      },
      isNegativeDisabled: {
        type: Boolean,
        default: false,
      },
      isDownloadDisabled: {
        type: Boolean,
        default: false,
      },
      isCommentsDisabled: {
        type: Boolean,
        default: false,
      },
      updateText:{
        type: String,
        default: 'Save Details',
      },
      cancelText:{
        type: String,
        default: 'Cancel',
      },
      downloadText:{
        type: String,
        default: 'Download PDF',
      },
      commentsText:{
        type: String,
        default: 'Save Comments',
      },
    },
    computed:{
      ...windowsComputed,
    },
    methods:{
      toggleLocalTransform(el){
        el.classList.remove('!tw-translate-x-0');
        el.classList.add('!tw-translate-x-0');
        setTimeout(() => {
          el.classList.remove('!tw-translate-x-0');
        }, 2000)
      },
      handleUpdate(){
        this.$emit('widget-update');
        if (this.isMobile){
          this.toggleLocalTransform(this.$refs.submit)
        }
      },
      handleDownload(){
        this.$emit('widget-download');
        if (this.isMobile){
          this.toggleLocalTransform(this.$refs.download)
        }
      },
      handleComments(){
        this.$emit('widget-comments');
        if (this.isMobile){
          this.toggleLocalTransform(this.$refs.comments)
        }
      },
      handleCancel(){
        this.$emit('widget-cancel');
        if (this.isMobile){
          this.toggleLocalTransform(this.$refs.cancel)
        }
      },
    }
  }
</script>

<template>
  <div
    v-if="height > 600"
    class="btns-fixed btns-fixed-lowered fixed-body !tw-top-64 sm:!tw-top-[25rem]">
    <button
      ref="submit"
      type="button"
      :disabled="isDisabled || isPositiveDisabled"
      class="btn btn-positive btn-fixed-r"
      @click="handleUpdate">
      <span class="btn-icon">
        <SaveIcon size="1.5x"/>
      </span>
      <span class="btn-text">{{updateText}}</span>
    </button>
    <button
      v-if="hasDownload"
      ref="download"
      type="button"
      class="btn btn-primary btn-fixed-r"
      :disabled="isDisabled || isDownloadDisabled"
      @click="handleDownload">
      <span class="btn-icon">
        <DownloadIcon size="1.5x"/>
      </span>
      <span class="btn-text">{{downloadText}}</span>
    </button>
    <button
      v-if="hasSaveComments"
      ref="comments"
      type="button"
      class="btn btn-positive btn-fixed-r"
      :disabled="isDisabled || isCommentsDisabled"
      @click="handleComments">
      <span class="btn-icon">
        <MessageCircleIcon size="1.5x"/>
      </span>
      <span class="btn-text">{{commentsText}}</span>
    </button>
    <button
      ref="cancel"
      type="button"
      class="btn btn-outline-white btn-fixed-r tw-bg-white"
      :disabled="isDisabled || isNegativeDisabled"
      @click="handleCancel">
      <span class="btn-icon">
        <RotateCcwIcon size="1.5x" />
      </span>
      <span class="btn-text">{{cancelText}}</span>
    </button>
  </div>
</template>
